import React from 'react';
import PropTypes from 'prop-types';
import OutsideClickHandler from 'react-outside-click-handler';
import SVGIcon from './SVGIcon';
import Button from './Button';

class DownloadCSVButton extends React.Component {
  state = {
    dropDownOpen: false,
  };
  toggleDropDown = () => {
    this.setState(prevState => ({ dropDownOpen: !prevState.dropDownOpen }));
  };
  closeDropDown = () => {
    this.setState(() => ({ dropDownOpen: false }));
  };
  handelDownload = (csvType, fileName) => {
    this.closeDropDown();

    this.props.downloadAudience(csvType, this.props.reportType, fileName);
  };
  render() {
    return (
      <OutsideClickHandler onOutsideClick={this.closeDropDown}>
        <div className="DownloadCSVButton" data-html2canvas-ignore="true">
          <Button
            size="download-csv"
            onClick={this.toggleDropDown}
            disabled={this.props.downloadingCSV}
            loading={this.props.downloadingCSV}
            label={this.props.label}
          />
          {this.state.dropDownOpen && (
            <ul>

              {
                this.props.ableToDownloadCSV.map(item => (
                  <li key={item.value}>
                    <button
                      onClick={() => this.handelDownload(item.value, item.fileName)}
                      className="DownloadCSVButton_drop-down-button"
                    >
                      <span className="DownloadCSVButton_drop-down-button_inner">
                        <SVGIcon icon="download" />
                        <span>{item.id}.csv</span>
                      </span>
                    </button>
                  </li>
                ))

              }

            </ul>
          )}



        </div>
      </OutsideClickHandler>
    );
  }
}

DownloadCSVButton.propTypes = {
  downloadingCSV: PropTypes.bool.isRequired,
  downloadAudience: PropTypes.func.isRequired,
};

export default DownloadCSVButton;
